import { withAnalyticsTracking } from '../../../utils/withAnalyticsTracking'
import { StaticActionHandler } from '../actionHandlers'
import { TransactionsDaybooksActionType } from '../utils/getDaybooksActions'

export const daybooksActionHandlers: Record<TransactionsDaybooksActionType, StaticActionHandler> = {
  [TransactionsDaybooksActionType.Void]: withAnalyticsTracking(
    ({ openModal, voidDaybookTransactionModalId }) => {
      openModal(voidDaybookTransactionModalId)
    },
    'Daybooks',
    TransactionsDaybooksActionType.Void,
  ),

  [TransactionsDaybooksActionType.Reverse]: withAnalyticsTracking(
    ({ openModal, reverseDaybookTransactionModalId }) => {
      openModal(reverseDaybookTransactionModalId)
    },
    'Daybooks',
    TransactionsDaybooksActionType.Reverse,
  ),

  [TransactionsDaybooksActionType.CopyToDaybook]: withAnalyticsTracking(
    ({ handleCopyToDaybook }) => {
      handleCopyToDaybook()
    },
    'Daybooks',
    TransactionsDaybooksActionType.CopyToDaybook,
  ),
}
